import React, { useRef, useState } from "react";
import { Alert, Button, CircularProgress, Snackbar, TextField, Typography } from "@mui/material";
import LoginWrapper from "../../components/LoginWrapper";
import { useNavigate } from "react-router-dom";
import i18n from "i18n/i18n";
import { useBoundStore } from "store/store";
import { ReactComponent as InfoCircle } from "assets/Svgs/CheckCircle.svg";
import ErrorIcon from "@mui/icons-material/Error";
import { BeatLoader, CircleLoader } from "react-spinners";
import { isValidEmail } from "utils/helper";

function ResetPassword() {
  const { resetPasswordUser, resetPasswordLoader } = useBoundStore();

  let lang = navigator?.language.split("-")[0]; // e.g "de" from de-DE

  const navigate = useNavigate();

  const [loader, setLoader] = useState(false);

  const [alertType, setAlertType] = useState("");
  const [alertText, setAlertText] = useState("");

  const [requestType, setRequestType] = useState("");
  const [openSnackbar, setOpenSnackbar] = useState(false);

  const emailRef = useRef<HTMLInputElement>(null);

  const [loginEmail, setLoginEmail] = useState("");

  const handleEmailChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    let value = e.target.value;
    setLoginEmail(value);
  };

  const submitForm = async () => {
    if (loginEmail === "") {
      emailRef.current?.focus();
      return;
    }

    if(!isValidEmail(loginEmail)){
      setOpenSnackbar(true);
      setAlertType("error");
      setLoader(false);
      setAlertText("Bitte geben Sie eine gültige E-Mail-Adresse ein!");
      return;
    }

    const promises: any[] = [resetPasswordUser(loginEmail)]; // Ensure that promises is an array

    const result: any = await Promise.all(promises);

    try {
      if (result[0].status === 200) {
        let lang = navigator?.language.split("-")[0]; // e.g "de" from de-DE
        // if (result[0].data === "") {
        //   setOpenSnackbar(true);
        //   setAlertType("error");
        //   setLoader(false);
        //   setAlertText("Benutzer existiert nicht!");
        //   return;
        // }

        setOpenSnackbar(true);
        setAlertType("success");
        setLoader(false);
        // setAlertText(result[0].data);
        setAlertText(i18n(lang)?.reset_email_sent);
      } else {
        setOpenSnackbar(false);
        setAlertType("error");
        setLoader(false);
        setAlertText(result[0].data);
      }
    } catch (error) {
      setOpenSnackbar(false);
      setAlertType("error");
      setLoader(false);
      setAlertText(result[0].data);

      // Handle the error appropriately
    }
  };

  const handleClose = (
    event?: React.SyntheticEvent | Event,
    reason?: string
  ) => {
    if (reason === "clickaway") {
      return;
    }
    setAlertText("");
    setAlertType("");
    setOpenSnackbar(false);
  };

  return (
    <LoginWrapper
      showLogo={true}
      // showBanner={query.get("status")}
      // bannerContent={bannerJson[Number(query.get("status"))]}
    >
      <div className="content">
        <Typography variant="h6" textAlign={"center"}>
          {i18n(lang)?.reset_password}
        </Typography>

        {resetPasswordLoader === false && (
          <Snackbar
            className="bxShadow "
            open={openSnackbar}
            autoHideDuration={5000}
            onClose={handleClose}
            anchorOrigin={{ vertical: "top", horizontal: "right" }}
            key={"top" + "right"}
          >
            <Alert
              onClose={handleClose}
              icon={alertType === "success" ? <InfoCircle /> : <ErrorIcon />}
              sx={{ width: "100%" }}
              style={{ width: "289px" }}
              severity={alertType === "success" ? "success" : "error"}
            >
              {alertText}
            </Alert>
          </Snackbar>
        )}

        <Typography
          variant="subtitle2"
          textAlign={"center"}
          sx={{ marginTop: 1 }}
        >
          {i18n(lang)?.reset_password_detail}
        </Typography>
        <div className="form">
          <TextField
            id="outlined-basic"
            label={"E-Mail-" + i18n(lang).address}
            variant="outlined"
            className="inputField"
            onChange={handleEmailChange}
            inputRef={emailRef}
            error={loginEmail === "" ? false : !isValidEmail(loginEmail)}
          />

          <Button
            fullWidth
            variant="contained"
            sx={{
              marginTop: 3,
              backgroundColor: "var(--primary-color)",
              letterSpacing: 1.25,
            }}
            disabled={resetPasswordLoader || (loginEmail === "" ? false : !isValidEmail(loginEmail))}
            
            onClick={submitForm}
            className="lp125"
          >
           {resetPasswordLoader ? <CircularProgress  className="customLoader"/> : "" }
             {i18n(lang)?.request_email}
          </Button>

          <Typography
            className="backTo"
            onClick={() => {
              navigate("/login");
            }}
            component={"div"}
          >
            {i18n(lang)?.back_to_login}
          </Typography>
        </div>
      </div>
    </LoginWrapper>
  );
}

export default ResetPassword;
